module.exports = __webpack_public_path__ + "static/media/EastHampton_banner.72402cd3.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/img/projects/EastHampton_banner.JPG
// module id = 247
// module chunks = 0